import { createGlobalStyle } from 'styled-components';
import { ThemeProps } from "./themes";

type GlobalThemeProps = {
  theme: ThemeProps;
};


const GlobalStyle = createGlobalStyle`

  body {
    margin: 0;
    padding: 0;
    font-family: ${({ theme }: GlobalThemeProps) => theme.fontFamily1}, Helvetica, Sans-Serif;
  }

  p{
    line-height: 26.67px;
  }
`;
 
export default GlobalStyle;